import React from 'react';
import {usePhase} from '../contexts/PhaseContext';

const PhaseBanner = () => {
    const {phase, loading, getPhaseDisplay, formatTimeUntilTransition} = usePhase();

    if (loading) {
        return (
            <div className="bg-gray-100 border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
                    <div className="flex items-center justify-center">
                        <div className="animate-pulse text-sm text-gray-500">Loading phase information...</div>
                    </div>
                </div>
            </div>
        );
    }

    const phaseDisplay = getPhaseDisplay();
    const timeUntilTransition = formatTimeUntilTransition();

    const getPhaseMessage = () => {
        switch (phase.currentPhase) {
            case 'Uploading':
                return 'Artists can upload and modify their artwork';
            case 'Voting':
                return "Vote on artwork you'd like to swap with";
            case 'Closed':
                return 'No uploads or voting allowed';
            default:
                return phase.description || 'Unknown phase';
        }
    };

    const getNextTransitionMessage = () => {
        if (!phase.nextTransition || !timeUntilTransition) return null;

        return (
            <span className="text-sm opacity-75">
                → {phase.nextTransition.nextPhase} in {timeUntilTransition}
            </span>
        );
    };

    return (
        <div
            className={`border-b border-gray-200 ${
                phase.currentPhase === 'Uploading' ? 'bg-green-50' : phase.currentPhase === 'Voting' ? 'bg-blue-50' : 'bg-gray-50'
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${phaseDisplay.color}`}>
                            <span className="mr-1">{phaseDisplay.icon}</span>
                            {phaseDisplay.name}
                        </span>
                        <div className="text-sm text-gray-700">
                            <span className="font-medium">{phase.name}</span>
                            {phase.description && <span className="ml-2 text-gray-500">• {getPhaseMessage()}</span>}
                        </div>
                    </div>

                    {getNextTransitionMessage() && <div className="hidden sm:block text-gray-600">{getNextTransitionMessage()}</div>}
                </div>

                {/* Mobile version of next transition */}
                {getNextTransitionMessage() && <div className="sm:hidden mt-2 text-gray-600">{getNextTransitionMessage()}</div>}

                {/* Phase-specific help text */}
                <div className="mt-2 text-xs text-gray-500">
                    {phase.currentPhase === 'Uploading' && <div>✓ Upload new artwork • ✓ Edit existing pieces • ✓ Delete unwanted uploads</div>}
                    {phase.currentPhase === 'Voting' && <div>✓ Browse and vote on artwork • ✗ No artwork modifications allowed</div>}
                    {phase.currentPhase === 'Closed' && <div>✓ View previous matches • ✗ No uploads or voting allowed</div>}
                </div>
            </div>
        </div>
    );
};

export default PhaseBanner;
